import { ProgressBar } from "../ProgressBar";

/**
 * A thin sweeping bar shown while a list that is already on screen reloads after an action (an approval, a delete), so the
 * old rows do not just sit there unchanged for a few seconds. Nothing is rendered when idle; `label` names it for a screen reader.
 */
export const BusyBar = ({ active, label }: { active: boolean; label: string }) =>
  active ? <ProgressBar max={0} label={label} valueText={label} /> : null;
